import React from 'react';
import { useParams } from 'react-router-dom';
import { projectSections, slugify } from './Projects';
import ComingSoon from '../Components/comingSoon';

const ProjectDetail = () => {
  const { sectionName, projectName } = useParams();

  const section = projectSections.find(
    s => slugify(s.title) === sectionName
  );
  const project = section?.projects.find(
    p => slugify(p.name) === projectName
  );

  if (project.component) {
    const CustomComponent = project.component;
    return <CustomComponent project={project} section={section} />;
  }

  return (
    <ComingSoon />
  );
};

export default ProjectDetail; 